import React from 'react'
import {
    Flex,
    Button,
    Text,
    Link as ChakraLink,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {remCalc} from '../../../theme/_utils'
import {FormattedMessage} from 'react-intl'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import ProductTileImage from '../../product-tile/partials/product-tile-image'

const RecipeUtilityTile = ({styles, tile}) => {
    const navigate = useNavigation()

    const handleNavigateToPdp = () => {
        navigate(tile?.c_slugUrl)
    }

    return (
        <Flex
            data-testid="made-with-tile-testid"
            {...styles.tile}
            maxW={{base: '100%', lg: remCalc(168)}}
            minH={{base: 'unset', lg: remCalc(380)}}
            flexDir="column"
            alignItems="stretch"
            gap={{base: 'xsmall.base', md: 'medium.base'}}
        >
            <Flex
                {...styles.tile?.imagecontainer}
                w={remCalc(168)}
                h={remCalc(168)}
                alignSelf="center"
            >
                <ProductTileImage
                    product={tile}
                    variant="freeItemPromo"
                    isInformativeLabelActive={false}
                />
            </Flex>
            <Flex flexDir="column" gap="xxsmall.base" px="xsmall.base">
                <ChakraLink
                    href={tile?.c_slugUrl}
                    textStyle="head-xxsmall"
                    fontWeight="medium"
                    textAlign="center"
                    overflow="hidden"
                    display="-webkit-box"
                    sx={{WebkitLineClamp: 2, WebkitBoxOrient: 'vertical'}}
                    _hover={{textDecoration: 'none'}}
                >
                    {tile?.c_defaultName}
                </ChakraLink>
                <Text textStyle="body-xsmall" color="text.secondary" textAlign="center">
                    {tile?.name}
                </Text>
            </Flex>
            <Flex mt="auto" justifyContent="center">
                <Button
                    onClick={handleNavigateToPdp}
                    variant="primary"
                    textStyle="body-xsmall"
                    fontWeight="medium"
                    w="100%"
                >
                    <FormattedMessage
                        id="recipes.details_page.carousel.discover_more"
                        defaultMessage="Discover More"
                    />
                </Button>
            </Flex>
        </Flex>
    )
}

RecipeUtilityTile.propTypes = {
    tile: PropTypes.shape({
        c_defaultName: PropTypes.string,
        name: PropTypes.string,
        c_slugUrl: PropTypes.string,
    }),
    styles: PropTypes.shape(),
}

export default RecipeUtilityTile
